import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
let ReminderSettingModel = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('boolean'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('number'), _dec13 = attr('number'), _dec14 = belongsTo('contact', {
  inverse: 'reminder_settings',
  async: false
}), _dec15 = attr('boolean'), _dec16 = attr('string'), _dec17 = attr('boolean', {
  defaultValue: false
}), _class = class ReminderSettingModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "send_type", _descriptor, this);
    _initializerDefineProperty(this, "send_when_number", _descriptor2, this);
    _initializerDefineProperty(this, "send_when_unit", _descriptor3, this);
    _initializerDefineProperty(this, "send_to", _descriptor4, this);
    _initializerDefineProperty(this, "send_to_id", _descriptor5, this);
    _initializerDefineProperty(this, "send_to_mail", _descriptor6, this);
    _initializerDefineProperty(this, "send_to_mobile", _descriptor7, this);
    _initializerDefineProperty(this, "send_from", _descriptor8, this);
    _initializerDefineProperty(this, "send_from_id", _descriptor9, this);
    _initializerDefineProperty(this, "send_from_mail", _descriptor0, this);
    _initializerDefineProperty(this, "is_client", _descriptor1, this);
    _initializerDefineProperty(this, "model", _descriptor10, this);
    _initializerDefineProperty(this, "contact_status_id", _descriptor11, this);
    _initializerDefineProperty(this, "reminder_scheduled", _descriptor12, this);
    _initializerDefineProperty(this, "reminder_scheduled_cost", _descriptor13, this);
    _initializerDefineProperty(this, "contact", _descriptor14, this);
    _initializerDefineProperty(this, "usa_personalizzato", _descriptor15, this);
    _initializerDefineProperty(this, "testo_personalizzato", _descriptor16, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor17, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "send_type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "send_when_number", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "send_when_unit", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "send_to", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "send_to_id", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "send_to_mail", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "send_to_mobile", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "send_from", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "send_from_id", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "send_from_mail", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "is_client", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "model", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "contact_status_id", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "reminder_scheduled", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "reminder_scheduled_cost", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "contact", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "usa_personalizzato", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "testo_personalizzato", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ReminderSettingModel as default };
//# sourceMappingURL=reminder-setting.js.map
